// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tile--aEAAB{display:flex;align-items:center;justify-content:center;padding:8px 14px;overflow:hidden;background-color:#fff;border:1px solid #d7dae4;border-radius:8px;cursor:pointer;transition:border-color .15s ease}.tile--aEAAB:hover{border-color:#96a0b4}.tile--aEAAB.selected--nSDMc{border-color:#5645f5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tile": "tile--aEAAB",
	"selected": "selected--nSDMc"
};
export default ___CSS_LOADER_EXPORT___;
